import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InlineNotice } from '@wit-support/ui';
import { Pause } from 'lucide-react';
import { AdsTime } from './ads-time.js';
/**
 * Пауза конструктора словами. Новый auto-ads присылает `pauseInfo` (кто и
 * почему); старый — только `manualPause` (с `source`/`reason` или без них —
 * тогда это пауза человека).
 */
export function pauseView(pause, info) {
    if (info != null) {
        const system = info.source === 'system' || info.reason === 'batch-cancelled';
        return { at: info.at, system, by: system ? null : (info.by ?? null) };
    }
    if (pause == null)
        return null;
    const system = pause.source === 'system' || pause.reason === 'batch-cancelled';
    return { at: pause.at, system, by: system ? null : (pause.by ?? null) };
}
/**
 * Отметка паузы конструктора под статусом «На паузе»: «Вручную: кто, когда»
 * или «Пачку отменили, когда» (системная пауза при отмене пачки до старта —
 * это не ручная пауза неизвестного). `compact` — строкой под статусом в
 * списке пачки; иначе — плашкой на карточке запуска. Показывается только
 * пока запуск действительно «На паузе» (`displayStatus = paused`): после
 * отката или после того, как кампанию включили снова, отметка в документе
 * может остаться, но «откатить можно» уже неправда.
 */
export function ManualPauseNote({ pause, info, compact = false, }) {
    const v = pauseView(pause, info);
    if (v == null)
        return null;
    const who = v.by ?? 'кто — неизвестно';
    if (compact) {
        return (_jsxs("div", { className: "text-xs text-[var(--color-text-muted)]", "data-testid": "manual-pause", children: [v.system ? 'Пачку отменили' : `Вручную: ${who}`, ",", ' ', _jsx(AdsTime, { iso: v.at, preset: "shortNumeric" })] }));
    }
    return (_jsx(InlineNotice, { variant: "info", bordered: true, icon: Pause, as: "div", "data-testid": "manual-pause", children: _jsxs("span", { children: [v.system ? (_jsxs(_Fragment, { children: ["\u041F\u0430\u0447\u043A\u0443 \u043E\u0442\u043C\u0435\u043D\u0438\u043B\u0438 \u0434\u043E \u0441\u0442\u0430\u0440\u0442\u0430 \u2014 \u0437\u0430\u043F\u0443\u0441\u043A \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u043F\u0430\u0443\u0437\u0443 (", _jsx(AdsTime, { iso: v.at, preset: "dateTime" }), "), \u0447\u0442\u043E\u0431\u044B \u043D\u0435 \u043D\u0430\u0447\u0430\u043B \u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0431\u044E\u0434\u0436\u0435\u0442."] })) : (_jsxs(_Fragment, { children: ["\u041F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u043F\u0430\u0443\u0437\u0443 \u0432\u0440\u0443\u0447\u043D\u0443\u044E (", who, ", ", _jsx(AdsTime, { iso: v.at, preset: "dateTime" }), ")."] })), ' ', "\u041A\u0430\u043C\u043F\u0430\u043D\u0438\u044F \u043D\u0435 \u0442\u0440\u0430\u0442\u0438\u0442 \u0431\u044E\u0434\u0436\u0435\u0442; \u043E\u0442\u043A\u0430\u0442\u0438\u0442\u044C \u043C\u043E\u0436\u043D\u043E, \u043F\u043E\u043A\u0430 \u0435\u0451 \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u0441\u043D\u043E\u0432\u0430 \u0432 Ads Manager."] }) }));
}
//# sourceMappingURL=manual-pause-note.js.map